import { useCookies } from "vue3-cookies";

/**
 * Determine if the current user should be treated as unauthenticated.
 *
 * In browser runtime we rely on presence of the secure/profile cookies.
 * In Node test or SSR environments there is no document (and vue3-cookies would
 * attempt to access document.cookie). In those cases we conservatively treat the
 * user as authenticated (return false) unless VITE_UNAUTH explicitly forces
 * unauth state. This avoids ReferenceError: document is not defined after
 * vitest environment teardown.
 */
export default function isUnauth() {
  // Explicit override via env flag
  if (import.meta.env.VITE_UNAUTH === "true") return true;

  // Guard for non-browser environments (SSR / node tests) where document is undefined
  if (typeof document === "undefined") {
    return false; // assume authenticated to prevent unauth-only code paths relying on DOM
  }

  try {
    const cookies = useCookies().cookies;
    return !cookies.get("x-lacp-secure") || !cookies.get("x-lacp-profile");
  } catch {
    // Fallback: if cookies access throws (unexpected), treat as authenticated
    return false;
  }
}
